/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { areDatesEqual } from 'utils/common';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Cookie from '../../utils/cookies';

class TrueCallerLogin extends React.Component {
  constructor() {
    super();
    this.moduleName = 'truecaller';
    this.state = {
      enableStyle: false,
    };
  }

  onShowCallback(value) {
    if (
      window &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[this.moduleName]
    ) {
      window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
        value,
      );
    }
  }

  openTrueCallerPopup = e => {
    e.preventDefault();
    e.stopPropagation();
    analyticsWrapper('ga4', {
      event: 'truecaller_component',
      type: 'truecaller',
      category: 'request_sent',
    });
    analyticsWrapper(
      'gaAndGrx',
      'send',
      'event',
      'truecaller',
      'request_sent',
      'truecaller_component',
    );
    this.props.jssoObj.truecallerOneTapLoginV1(
      sucessResponse => {
        console.log('True caller: Successfully logged in', sucessResponse);
        this.props.jssoObj.getUserDetails(response => {
          const createdDateStr = response?.data?.createdDate;
          const createdDate = new Date(createdDateStr);
          const currentDate = new Date();
          analyticsWrapper('ga4', {
            event: 'user_login',
            type: 'truecaller',
            category: 'truecaller_one_tap',
            label: areDatesEqual(createdDate, currentDate) ? 'signup' : 'login',
          });
          analyticsWrapper(
            'gaAndGrx',
            'send',
            'event',
            'truecaller',
            'user_login',
            'truecaller_one_tap',
          );
        });
        this.props.loginUserCallback();
      },
      errorResponse => {
        if (errorResponse?.failedType) {
          const map = {
            APP_NOT_INSTALLED: 'not_installed',
            TIMEOUT: 'timeout',
          };
          if (errorResponse?.failedType === 'APP_NOT_INSTALLED') {
            analyticsWrapper('ga4', {
              event: 'truecaller_component',
              category: 'app_not_installed',
              type: 'truecaller',
            });
            analyticsWrapper(
              'gaAndGrx',
              'send',
              'event',
              'truecaller',
              'app_not_installed',
              'truecaller_component',
            );
          } else if (errorResponse?.failedType === 'TIMEOUT') {
            analyticsWrapper('ga4', {
              event: 'truecaller_component',
              category: 'component_timeout',
              type: 'truecaller',
            });
            analyticsWrapper(
              'gaAndGrx',
              'send',
              'event',
              'truecaller',
              'component_timeout',
              'truecaller_component',
            );
          }
          if (map[errorResponse?.failedType] === map.APP_NOT_INSTALLED) {
            this.onShowCallback(false);
          }
        }
      },
      popUpCallback => {
        if (popUpCallback?.type) {
          if (popUpCallback?.type === 'OPEN') {
            analyticsWrapper('ga4', {
              event: 'truecaller_component',
              type: 'truecaller',
              category: 'component_shown',
            });
            analyticsWrapper(
              'gaAndGrx',
              'send',
              'event',
              'truecaller',
              'component_shown',
              'truecaller_component',
            );
            this.onShowCallback(true);
          } else if (popUpCallback?.type === 'SKIP') {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: 'truecaller',
              category: 'skip',
            });
            analyticsWrapper(
              'gaAndGrx',
              'send',
              'event',
              'truecaller',
              'user_click',
              'skip',
            );
          }
        }
      },
    );
    this.setState({ enableStyle: false });
  };

  componentDidMount() {
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(this.moduleName, () => {
            const { isWapView } = this.props;
            this.channel = isWapView ? 'toi-wap' : 'toi';
            const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
            if (
              ssoid ||
              !isWapView ||
              !window.location.href.includes('/sports')
            ) {
              // user id is already exists
              this.onShowCallback(false);
              return;
            }
            if (
              isWapView &&
              typeof window === 'object' &&
              window.TimesGDPR &&
              window.TimesGDPR.common.consentModule.gdprCallback
            ) {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  this.props.jssoObj?.truecallerOneTapLoginV1 &&
                  typeof this.props.jssoObj?.truecallerOneTapLoginV1 ===
                    'function' &&
                  (!(
                    dataObj.isEUuser ||
                    (dataObj.userCountry === 'US' &&
                      dataObj.userRegion === 'CA')
                  ) ||
                    dataObj.consentGiven)
                ) {
                  this.setState({
                    enableStyle: true,
                  });
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }

  render() {
    return this.props.isWapView ? (
      <div
        className="truecaller_onetap_wrapper"
        id="truecaller_onetap_wrapper"
        style={
          this.state.enableStyle
            ? {
                position: 'absolute',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                zIndex: 100000000000,
              }
            : {}
        }
        onClick={this.state.enableStyle ? this.openTrueCallerPopup : undefined}
      />
    ) : (
      <></>
    );
  }
}

export default TrueCallerLogin;
